import { useTradingStore } from '../hooks/useTradingStore'
import { TrendingUp, TrendingDown } from 'lucide-react'

export default function SpreadMonitor() {
  const { spreadData } = useTradingStore()

  const bid = spreadData?.bid ?? 0
  const ask = spreadData?.ask ?? 0
  const spread = spreadData?.spread ?? 0
  const spreadBps = bid > 0 ? (spread / bid) * 10000 : 0

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Bid/Ask Spread</h3>
        <span className="text-xs text-[#666]">Real-time</span>
      </div>

      <div className="space-y-3">
        {/* Bid */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp size={14} className="text-green-400" />
            <span className="text-sm text-[#a0a0a0]">Bid</span>
          </div>
          <span className="text-lg font-mono font-semibold text-green-400">
            ${bid.toFixed(2)}
          </span>
        </div>

        {/* Ask */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingDown size={14} className="text-red-400" />
            <span className="text-sm text-[#a0a0a0]">Ask</span>
          </div>
          <span className="text-lg font-mono font-semibold text-red-400">
            ${ask.toFixed(2)}
          </span>
        </div>

        {/* Spread */}
        <div className="pt-3 border-t border-[#2a2a2a]">
          <div className="flex items-center justify-between">
            <span className="text-sm text-[#a0a0a0]">Spread</span>
            <div className="text-right">
              <span className="text-lg font-mono font-semibold text-white">
                ${spread.toFixed(4)}
              </span>
              <span className="text-xs text-[#666] ml-2">
                ({spreadBps.toFixed(2)} bps)
              </span>
            </div>
          </div>
        </div>

        {/* Spread Visual Bar */}
        <div className="h-2 bg-[#1a1a1a] rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-green-500 to-red-500 transition-all duration-300"
            style={{ width: `${Math.min(spreadBps * 10, 100)}%` }}
          />
        </div>
      </div>
    </div>
  )
}
